import { render, staticRenderFns } from "./PreferencesSetting.vue?vue&type=template&id=df09373e&"
import script from "./PreferencesSetting.vue?vue&type=script&lang=js&"
export * from "./PreferencesSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/allianzebpo/public_html/payment/crater/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df09373e')) {
      api.createRecord('df09373e', component.options)
    } else {
      api.reload('df09373e', component.options)
    }
    module.hot.accept("./PreferencesSetting.vue?vue&type=template&id=df09373e&", function () {
      api.rerender('df09373e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/PreferencesSetting.vue"
export default component.exports